// Imports
//=require ../source/js/modernizr-custom.js
//=require svg4everybody/dist/svg4everybody.min.js
//=require lazysizes/lazysizes.min.js
//=require jquery/dist/jquery.min.js
//=require jquery-validation/dist/jquery.validate.min.js
//=require jquery-mask-plugin/dist/jquery.mask.min.js

svg4everybody();

/**
 * Focus on keydown
 */

let keyboardNavigation = false;

$(document).on('keydown', function (e) {
    if (e.key == 'Tab') {
        $('body').addClass('is-keyboard-pressed');
        keyboardNavigation = true;
    };
});

$(document).on('click mousedown', function (e) {
    var $target = $(e.target);
    if ($target.is(':radio, :checkbox, :button, a[href="#"]')) {
        if (keyboardNavigation == false) {
            $('body').removeClass('is-keyboard-pressed');
            keyboardNavigation = false;
        }
    } else {
        $('body').removeClass('is-keyboard-pressed');
        keyboardNavigation = false;
    }
});
$('input[type=radio], input[type=checkbox], button[type="button"], a[href="#"]').on('keydown', function (e) {
    $('body').addClass('is-keyboard-pressed');
    keyboardNavigation = true;
});

function setInputFilter(textbox, inputFilter) {
    ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function (event) {
        textbox.addEventListener(event, function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty('oldValue')) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
        });
    });
}

// DOM
var MyApp = {

    onlyNumbers: function () {
        $('.only-numbers').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9]*$/.test(value);
            });
        });
    },
    onlyLetters: function () {
        $('.only-letters').each(function () {
            setInputFilter(this, function (value) {
                return /^[a-zA-ZáéíóúÁÉÍÓÚ\'´ñÑäëïöüÄËÏÖÜ \-]*$/.test(value);
            });
        });
    },
    onlyAlphaNumeric: function () {
        $('.only-alpha-numeric').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9a-zA-Z]*$/.test(value);
            });
        });
    },
    onlyPhone: function () {
        $('.only-phone').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9\-]*$/.test(value);
            });
        });
        $('.only-phone').mask('000-000-0000');
    },
    onlyDate: function () {
        $('.only-date').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9\/]*$/.test(value);
            });
        });
    },
    form: function () {
        $.validator.methods.email = function (value, element) {
            return this.optional(element) || /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i.test(value);
        }

        let checkboxName = $('.quote-form-checkboxes__input').attr('name');

        $('.form').each(function () {
            $(this).validate({
                errorClass: 'form__error',
                validClass: 'form__valid',
                errorPlacement: function (error, element) {
                    if (element.attr('name') == checkboxName) {
                        $('.quote-form-checkboxes__error').html(error);
                    }
                    else {
                        error.insertAfter(element);
                    }
                },
                submitHandler: function (form) {
                    $(form).addClass('is-loading');
                    $('.quote-form-inputs__submit').prop('disabled', true);
                    form.submit();
                }
            });
        });

        let categorySelected = false;

        $('.quote-form-radios__input').on('change', function () {
            if (categorySelected == false) {
                $('.js-quote-products, .js-quote-information').fadeIn();
                categorySelected = true;
            }

            let category = $(this).val();

            $('.quote-form-checkboxes__item').removeClass('is-active').find('.quote-form-checkboxes__input').prop('disabled', true).prop('checked', false);
            $('.quote-form-checkboxes__item[data-category=' + category + ']').addClass('is-active').find('.quote-form-checkboxes__input').prop('disabled', false);
        });

        if ($('[name="' + checkboxName + '"]').length) {
            $('[name="' + checkboxName + '"]').rules('add', {
                required: true,
                minlength: 1,
                messages: {
                    required: 'Please select at least one product'
                }
            });
        }

        if ($('#zipcode').length) {
            $('#zipcode').rules('add', {
                required: true,
                minlength: 3,
                maxlength: 5,
                remote: {
                    url: 'https://www.confiejarvis.com/thor/javascript?',
                    data: {
                        zipcode: function () { return $('#zipcode').val(); }
                    },
                    dataFilter: function (data) {
                        if (data === "1") {
                            return '"true"';
                        }
                        return '"Enter a valid zip code"';
                    }
                },
                messages: {
                    required: 'Enter your zip code'
                }
            });
        }

        if ($('#firstName').length) {
            $('#firstName').rules('add', {
                required: true,
                minlength: 2,
                messages: {
                    required: 'Enter your first name'
                }
            });
        }
        if ($('#lastName').length) {
            $('#lastName').rules('add', {
                required: true,
                minlength: 2,
                messages: {
                    required: 'Enter your last name'
                }
            });
        }
        if ($('#gender').length) {
            $('#gender').rules('add', {
                required: true,
                messages: {
                    required: 'Select a gender'
                }
            });
        }
        if ($('#email').length) {
            $('#email').rules('add', {
                required: true,
                minlength: 3,
                maxlength: 255,
                messages: {
                    required: 'Enter your email'
                }
            });
        }
        if ($('#phone').length) {
            $('#phone').rules('add', {
                required: true,
                minlength: 12,
                maxlength: 12,
                messages: {
                    required: 'Enter your phone number',
                    minlength: 'You must enter 10 digits',
                    maxlength: 'You must enter 10 digits',
                }
            });
        }
    }
}

// On ready

$(function () {

    if ($('.only-numbers').length) {
        MyApp.onlyNumbers();
    }
    if ($('.only-letters').length) {
        MyApp.onlyLetters();
    }
    if ($('.only-alpha-numeric').length) {
        MyApp.onlyAlphaNumeric();
    }
    if ($('.only-phone').length) {
        MyApp.onlyPhone();
    }
    if ($('.form').length) {
        MyApp.form();
    }
});